export const OS = {
  windows: 'Windows',
  mac: 'Mac',
  lowerCase: {
    windows: 'windows',
    mac: 'mac',
  },
};
